// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckboxV2-module__root--VyhwO","checked":"CheckboxV2-module__checked--3vSGH","disabled":"CheckboxV2-module__disabled--2A3i1"};